import {
  SET_CORPORATE_LOCATIONS_LIST,
  SET_SINGLE_LOCATIONS,
} from 'modules/Settings/actions'

const initialState = {
  corporateLocationsList: {},
  singleLocationData: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CORPORATE_LOCATIONS_LIST:
      return {
        ...state,
        corporateLocationsList: action.data,
      }
    case SET_SINGLE_LOCATIONS:
      return {
        ...state,
        singleLocationData: action.data,
      }
    default:
      return state
  }
}
